import { FC } from "react";
import ConditionalSubtext from "../MarketInsigtsHeading/conditionalSubtext";
import IpoList from "../IpoList/IpoList";
const UpcomingIpo: FC<any> = (data: any) => {
  const headerTitle = data?.ipoTitle ?? "Upcoming IPO in 2026";
  const headerDescription =
    data?.ipoDescription ??
    "Find all IPOs in one place—past, present, and upcoming. Get key details like issue size, price band, subscription dates, and listing status. Explore this comprehensive list to track companies entering the stock market";
  const ipoListItems = Object?.values(data?.ipoListItems || {});

  return (
    <section>
      <header className="flex flex-col gap-[4px] pb-[12px] pl-[16px] pr-[16px] pt-[12px] md:pl-[24px] lg:pb-[16px] lg:pl-[144px] lg:pr-[16px] lg:pt-[16px]">
        <h1 className="font-rubik ipo-title text-[20px] font-medium leading-none text-[#1A1A1A] md:text-[22px]">
          {headerTitle}
        </h1>
        <ConditionalSubtext
          className="max-w-[727px] text-[#1A1A1A]"
          subtext={headerDescription}
        />
      </header>

      {ipoListItems.map((ipoData: any, index: number) => (
        <div key={"ipoList-" + (ipoData?.componentLink ?? index)}>
          <div className="gap-[12px] pb-[12px] pl-[16px] pr-[16px] pt-[16px] lg:pl-[141px] lg:pt-[24px]">
            <IpoList
              componentLink={ipoData?.componentLink}
              headingLevel={ipoData?.headingLevel ?? data?.headingLevel}
              ipoTitle={ipoData?.ipoTitle ?? ""}
              mainboardTitle={ipoData?.mainboardTitle}
              smeTitle={ipoData?.smeTitle}
              viewAllText={ipoData?.viewAllText}
              biddingPeriodText={ipoData?.biddingPeriodText}
              minimumInvestmentText={ipoData?.minimumInvestmentText}
              bidPriceText={ipoData?.bidPriceText}
              listingDateText={ipoData?.listingDateText}
              listingGainText={ipoData?.listingGainText}
              pageType={ipoData?.pageType}
              showMoreCtaText={ipoData?.showMoreCtaText}
              paginationLimit={ipoData?.paginationLimit}
              ipoType={ipoData?.ipoType}
              redirectToPdpBaseUrl={ipoData?.redirectToPdpBaseUrl}
              apiErrorDesc={ipoData?.apiErrorDesc}
              fetchApiDataErrorDesc={ipoData?.fetchApiDataErrorDesc}
              viewAllRedirectUrl={ipoData?.viewAllRedirectUrl}
              viewAllOpenNewTab={ipoData?.viewAllOpenNewTab}
              addSeperatorComponent={ipoData?.addSeperatorComponent}
              tbaText={ipoData?.tbaText}
              signInText={ipoData?.signInText}
              customClass=""
            />
          </div>
          <hr className="h-[2px] border-none bg-blue-100 pl-[16px] lg:ml-[120px] lg:max-w-[900px]" />
        </div>
      ))}
    </section>
  );
};

export default UpcomingIpo;
